const config = {
  defaultPath: '/dashboard',
  fontFamily: `'Adobe Clean UX', sans-serif`,
  i18n: 'en',
  miniDrawer: false,
  container: true,
  mode: 'light',
  presetColor: 'default',
  themeDirection: 'ltr',
};

export default config;
export const drawerWidth = 150;
export const loaderTimeout = 2000;
export const appMinDate = new Date('2024-04-01');

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
